import { Box, Typography, alpha } from "@mui/material"

const CopyRight = () => {
  return (
    <Box sx={{ width: '100%', py: 5, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Typography sx={{ color: alpha('#fff', 0.5) }}>Copyright © 2024 CMJ, All rights reserved.</Typography>
    </Box>
  )
}

export default CopyRight
